(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[365],{

/***/ 4876:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/member-enrollment/one-click",
      function () {
        return __webpack_require__(71964);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86886);



var StepCard = function(param) {
    var children = param.children, testId = param.testId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        container: true,
        direction: "column",
        sx: {
            width: {
                xs: "100vw",
                sm: "408px"
            },
            display: "flex",
            alignItems: "center",
            "& h1": {
                paddingBottom: 2
            },
            "& .MuiFormControl-root": {
                // remove input field padding
                padding: 0
            },
            overflowWrap: {
                xs: "anywhere",
                sm: null
            },
            px: {
                xs: 3,
                sm: 0
            },
            py: {
                xs: 0,
                sm: 0
            }
        },
        "data-testid": testId,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StepCard);


/***/ }),

/***/ 99051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export policyClickData */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5616);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23795);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42660);





// Constants
var ref = next_config__WEBPACK_IMPORTED_MODULE_2___default()(), CZEN_GENERAL = ref.publicRuntimeConfig.CZEN_GENERAL;
var TERMS_OF_USE = _constants__WEBPACK_IMPORTED_MODULE_3__/* .TEXTS.STATIC.TERMS_OF_USE */ .oS.STATIC.TERMS_OF_USE;
/* eslint-disable camelcase */ var policyClickData = {
    terms: {
        name: _constants__WEBPACK_IMPORTED_MODULE_3__/* .EventNames.TERMS_OF_USE_CLICKED */ .Vy.TERMS_OF_USE_CLICKED,
        link_text: "Terms of Use"
    },
    privacy: {
        name: _constants__WEBPACK_IMPORTED_MODULE_3__/* .EventNames.PRIVACY_POLICY_CLICKED */ .Vy.PRIVACY_POLICY_CLICKED,
        link_text: "Privacy Policy"
    }
};
var TermsOfUse = function(param) {
    var amplitudeLogger = param.amplitudeLogger, buttonCaption = param.buttonCaption, _flat = param.flat, flat = _flat === void 0 ? false : _flat, _variant = param.variant, variant = _variant === void 0 ? "full" : _variant;
    var handlePolicyEvent = function(key) {
        return function() {
            return amplitudeLogger(policyClickData[key]);
        };
    };
    var abbreviatedTOU = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        component: "div",
        sx: flat ? null : {
            marginTop: 2,
            marginBottom: 2
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            variant: "body3",
            color: "textSecondary",
            children: [
                "By choosing ",
                buttonCaption,
                " you agree to our\xa0",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    id: "terms-of-use-link",
                    underline: "always",
                    onClick: handlePolicyEvent("terms"),
                    href: "".concat(CZEN_GENERAL, "/enterprise/terms.do"),
                    target: "_blank",
                    variant: "link3",
                    rel: "noreferrer",
                    children: policyClickData.terms.link_text
                }),
                " and ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    id: "privacy-policy-link",
                    underline: "always",
                    onClick: handlePolicyEvent("privacy"),
                    href: "".concat(CZEN_GENERAL, "/about/privacy-policy/"),
                    variant: "link3",
                    target: "_blank",
                    rel: "noreferrer",
                    children: policyClickData.privacy.link_text
                }),
                "."
            ]
        })
    });
    var fullTOU = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            abbreviatedTOU,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                sx: {
                    marginTop: 2
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    variant: "body3",
                    color: "textSecondary",
                    children: TERMS_OF_USE.CONTENT
                })
            })
        ]
    });
    if (variant === "abbreviated") {
        return abbreviatedTOU;
    }
    if (variant === "universal") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            variant: "disclaimer2",
            color: function(theme) {
                return theme.palette.care.white;
            },
            children: [
                "By clicking ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                    children: buttonCaption
                }),
                " you agree to our\xa0",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    id: "terms-of-use-link",
                    underline: "always",
                    onClick: handlePolicyEvent("terms"),
                    href: "".concat(CZEN_GENERAL, "/enterprise/terms.do"),
                    target: "_blank",
                    variant: "link4",
                    rel: "noreferrer",
                    sx: function(theme) {
                        return {
                            color: theme.palette.care.white,
                            "&:hover,&:focus,&:focus:active": {
                                color: theme.palette.care.white
                            }
                        };
                    },
                    children: policyClickData.terms.link_text
                }),
                " and ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    id: "privacy-policy-link",
                    underline: "always",
                    onClick: handlePolicyEvent("privacy"),
                    href: "".concat(CZEN_GENERAL, "/about/privacy-policy/"),
                    variant: "link4",
                    target: "_blank",
                    rel: "noreferrer",
                    sx: function(theme) {
                        return {
                            color: theme.palette.care.white,
                            "&:hover,&:focus,&:focus:active": {
                                color: theme.palette.care.white
                            }
                        };
                    },
                    children: policyClickData.privacy.link_text
                }),
                "."
            ]
        });
    }
    return fullTOU;
};
/* harmony default export */ __webpack_exports__["Z"] = (TermsOfUse);


/***/ }),

/***/ 71964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ OneClick; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/LandingPageHeader/LandingPageHeader.js
var LandingPageHeader = __webpack_require__(68518);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@care/enterprise-components/dist/components/AppFooter/index.js + 10 modules
var AppFooter = __webpack_require__(3869);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./src/context/FeatureFlagsContext.tsx
var FeatureFlagsContext = __webpack_require__(13854);
// EXTERNAL MODULE: ./src/components/shared/Layout.tsx
var Layout = __webpack_require__(72317);
// EXTERNAL MODULE: ./src/components/shared/CareLogo.tsx
var CareLogo = __webpack_require__(91133);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 5 modules
var _sliced_to_array = __webpack_require__(70603);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 5 modules
var formik_esm = __webpack_require__(56263);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 2 modules
var useQuery = __webpack_require__(6812);
// EXTERNAL MODULE: ./node_modules/@care/enterprise-components/dist/components/ErrorNotification/index.js + 1 modules
var ErrorNotification = __webpack_require__(94587);
// EXTERNAL MODULE: ./src/components/shared/StepCard.tsx
var StepCard = __webpack_require__(82383);
// EXTERNAL MODULE: ./src/components/shared/StepCTA.tsx
var StepCTA = __webpack_require__(68838);
// EXTERNAL MODULE: ./src/components/shared/TermsOfUse.tsx
var TermsOfUse = __webpack_require__(99051);
// EXTERNAL MODULE: ./src/utilities/analyticsHelper.ts + 1 modules
var analyticsHelper = __webpack_require__(44730);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/components/shared/blocks/FormikInlineTextField.tsx
var FormikInlineTextField = __webpack_require__(36011);
// EXTERNAL MODULE: ./src/components/hooks/useDirectEnrollmentData.ts + 1 modules
var useDirectEnrollmentData = __webpack_require__(86477);
;// CONCATENATED MODULE: ./src/components/pages/MemberEnrollment/OneClick/components/VerifyInfo/index.tsx






var _LABELS = constants/* TEXTS.LABELS */.oS.LABELS, FIRST_NAME = _LABELS.FIRST_NAME, LAST_NAME = _LABELS.LAST_NAME, _ONE_CLICK_ENROLLMENT = constants/* TEXTS.ONE_CLICK_ENROLLMENT */.oS.ONE_CLICK_ENROLLMENT, VERIFY_INFO_HEADING_SUFFIX = _ONE_CLICK_ENROLLMENT.VERIFY_INFO_HEADING_SUFFIX, VERIFY_INFO_SUBHEADING = _ONE_CLICK_ENROLLMENT.VERIFY_INFO_SUBHEADING, VERIFY_INFO_STEP_NAME = _ONE_CLICK_ENROLLMENT.VERIFY_INFO_STEP_NAME;
var VerifyInfo = function(param) {
    var logger = param.logger;
    var firstName = "firstName";
    var lastName = "lastName";
    var fetch = (0,useDirectEnrollmentData/* default */.ZP)().fetch;
    var groupDisplayName = fetch().groupDisplayName;
    (0,react.useEffect)(function() {
        logger({
            name: constants/* EventNames.SCREEN_VIEWED */.Vy.SCREEN_VIEWED,
            data: {
                step_name: VERIFY_INFO_STEP_NAME
            }
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "h1",
                children: [
                    groupDisplayName,
                    " ",
                    VERIFY_INFO_HEADING_SUFFIX
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "subtitle1",
                children: VERIFY_INFO_SUBHEADING
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikInlineTextField/* default */.Z, {
                name: firstName,
                id: firstName,
                label: FIRST_NAME,
                autoFocus: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikInlineTextField/* default */.Z, {
                name: lastName,
                id: lastName,
                label: LAST_NAME
            })
        ]
    });
};
/* harmony default export */ var components_VerifyInfo = (VerifyInfo);

// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 89 modules
var es = __webpack_require__(25576);
;// CONCATENATED MODULE: ./src/components/pages/MemberEnrollment/OneClick/components/schemaValidation.ts


var _ERRORS = constants/* TEXTS.ERRORS */.oS.ERRORS, NO_SPECIAL_CHARACTERS = _ERRORS.NO_SPECIAL_CHARACTERS, FIELD_CHARACTER_MAX = _ERRORS.FIELD_CHARACTER_MAX, MUST_CONTAIN_LETTER = _ERRORS.MUST_CONTAIN_LETTER, IS_REQUIRED = _ERRORS.IS_REQUIRED;
var noSpecialCharsRegex = /^[A-Za-z\-–—' ]*$/;
var onlyLettersRegex = /[A-Za-z]/;
var verifyInfoValidation = {
    firstName: es/* string */.Z_().required(IS_REQUIRED("First name")).test({
        name: "checkSpecialCharacter",
        message: NO_SPECIAL_CHARACTERS,
        test: function(value) {
            return noSpecialCharsRegex.test(value);
        }
    }).test({
        name: "checkLetterCharacter",
        message: MUST_CONTAIN_LETTER("First name"),
        test: function(value) {
            return onlyLettersRegex.test(value);
        }
    }).max(25, FIELD_CHARACTER_MAX("First Name", 25)),
    lastName: es/* string */.Z_().required(IS_REQUIRED("Last name")).test({
        name: "checkSpecialCharacter",
        message: NO_SPECIAL_CHARACTERS,
        test: function(value) {
            return noSpecialCharsRegex.test(value);
        }
    }).test({
        name: "checkLetterCharacter",
        message: MUST_CONTAIN_LETTER("Last name"),
        test: function(value) {
            return onlyLettersRegex.test(value);
        }
    })
};
var getOneClickSchemaValidation = function() {
    var validationSchema = es/* object */.Ry(verifyInfoValidation);
    return validationSchema;
};

// EXTERNAL MODULE: ./src/components/request/GQL.tsx
var GQL = __webpack_require__(5400);
// EXTERNAL MODULE: ./src/utilities/localStorageHelper.tsx
var localStorageHelper = __webpack_require__(57108);
// EXTERNAL MODULE: ./src/lib/AuthService.ts
var AuthService = __webpack_require__(75537);
// EXTERNAL MODULE: ./src/__generated__/globalTypes.ts
var globalTypes = __webpack_require__(79967);
// EXTERNAL MODULE: ./src/components/shared/OverlaySpinner.tsx + 1 modules
var OverlaySpinner = __webpack_require__(20594);
;// CONCATENATED MODULE: ./src/components/pages/MemberEnrollment/OneClick/helpers/logErrorViewed.ts

var logErrorViewed = function(logger, param) {
    var message = param.message, stepName = param.stepName;
    logger({
        name: constants/* EventNames.ERROR_VIEWED */.Vy.ERROR_VIEWED,
        data: {
            message: message,
            step_name: stepName
        }
    });
};

;// CONCATENATED MODULE: ./src/components/pages/MemberEnrollment/OneClick/components/Landing/index.tsx






var WELCOME_LANDING_PAGE_STEP_NAME = constants/* TEXTS.ONE_CLICK_ENROLLMENT.WELCOME_LANDING_PAGE_STEP_NAME */.oS.ONE_CLICK_ENROLLMENT.WELCOME_LANDING_PAGE_STEP_NAME;
var ref = config_default()(), NEXT_PUBLIC_CDN_ROOT = ref.publicRuntimeConfig.NEXT_PUBLIC_CDN_ROOT;
var Landing = function(param) {
    var logger = param.logger;
    var fetch = (0,useDirectEnrollmentData/* default */.ZP)().fetch;
    var firstName = fetch().firstName;
    (0,react.useEffect)(function() {
        logger({
            name: constants/* EventNames.SCREEN_VIEWED */.Vy.SCREEN_VIEWED,
            data: {
                step_name: WELCOME_LANDING_PAGE_STEP_NAME
            }
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "h1",
                color: "textPrimary",
                children: [
                    "Hi, ",
                    firstName,
                    "!"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body1",
                color: "textPrimary",
                children: "Create your free, employer-sponsored account today"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                component: "div",
                sx: {
                    display: "flex",
                    alignItems: "center",
                    mt: 1.5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        component: "img",
                        src: "".concat(NEXT_PUBLIC_CDN_ROOT, "/img/cms/web/careAtWork/directEnrollment/Babysitters.svg"),
                        sx: {
                            height: "75px",
                            width: "75px",
                            verticalAlign: "middle"
                        },
                        alt: "Babysitters"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "textPrimary",
                        children: "Get trusted backup care when you need it most"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                component: "div",
                sx: {
                    display: "flex",
                    alignItems: "center",
                    mt: 1.5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        component: "img",
                        src: "".concat(NEXT_PUBLIC_CDN_ROOT, "/img/cms/web/careAtWork/directEnrollment/Shield%20Check.svg"),
                        sx: {
                            height: "75px",
                            width: "75px",
                            verticalAlign: "middle"
                        },
                        alt: "Shield"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "textPrimary",
                        children: "Book a local, background-checked sitter"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                component: "div",
                sx: {
                    display: "flex",
                    alignItems: "center",
                    mt: 1.5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        component: "img",
                        src: "".concat(NEXT_PUBLIC_CDN_ROOT, "/img/cms/web/careAtWork/directEnrollment/Chat-Bubbles.svg"),
                        sx: {
                            height: "75px",
                            width: "75px",
                            verticalAlign: "middle"
                        },
                        alt: "ChatBubbles"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "textPrimary",
                        children: "Chat with caregivers to find the right fit faster"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Landing = (Landing);

// EXTERNAL MODULE: ./src/components/pages/MemberEnrollment/OneClick/helpers/passwordGenerate.ts
var passwordGenerate = __webpack_require__(78884);
// EXTERNAL MODULE: ./src/components/hooks/useEnterKey.ts
var useEnterKey = __webpack_require__(20566);
;// CONCATENATED MODULE: ./src/components/pages/MemberEnrollment/OneClick/components/PageContent.tsx





























var REQUEST_FAILED = constants/* TEXTS.ERRORS.REQUEST_FAILED */.oS.ERRORS.REQUEST_FAILED, PageContent_ONE_CLICK_ENROLLMENT = constants/* TEXTS.ONE_CLICK_ENROLLMENT */.oS.ONE_CLICK_ENROLLMENT, STREET_ADDRESS = PageContent_ONE_CLICK_ENROLLMENT.STREET_ADDRESS, ZIP_CODE = PageContent_ONE_CLICK_ENROLLMENT.ZIP_CODE, ELIGIBILITY_FAILURE = PageContent_ONE_CLICK_ENROLLMENT.ELIGIBILITY_FAILURE, PageContent_VERIFY_INFO_STEP_NAME = PageContent_ONE_CLICK_ENROLLMENT.VERIFY_INFO_STEP_NAME, PageContent_WELCOME_LANDING_PAGE_STEP_NAME = PageContent_ONE_CLICK_ENROLLMENT.WELCOME_LANDING_PAGE_STEP_NAME, ONE_CLICK_ENROLL_EVENT_NAME = PageContent_ONE_CLICK_ENROLLMENT.ONE_CLICK_ENROLL_EVENT_NAME, ONE_CLICK_ENROLL_V2_EVENT_NAME = PageContent_ONE_CLICK_ENROLLMENT.ONE_CLICK_ENROLL_V2_EVENT_NAME;
var WELCOME = constants/* ENTERPRISE_ROUTES.WELCOME */.O$.WELCOME;
var PageContent = function(param) {
    var groupName = param.groupName, employeeUUID = param.employeeUUID, isOneClickV2 = param.isOneClickV2;
    var router = (0,next_router.useRouter)();
    var authService = (0,AuthService/* default */.Z)();
    var ref = (0,useDirectEnrollmentData/* default */.ZP)(), update = ref.update, fetch = ref.fetch;
    var ref1 = (0,react.useState)(false), showVerifyInfo = ref1[0], setShowVerifyInfo = ref1[1];
    var ref2 = (0,react.useState)(false), showLandingPage = ref2[0], setShowLandingPage = ref2[1];
    var ref3 = (0,react.useState)(false), isSubmitting = ref3[0], setSubmitting = ref3[1];
    var ref4 = (0,react.useState)(true), isLoading = ref4[0], setIsLoading = ref4[1];
    var ref5 = (0,react.useState)(null), error = ref5[0], setError = ref5[1];
    var ctaType = "create";
    var createAccount = "Create account";
    var isOverlayOpen = isLoading || isSubmitting;
    var stepName = showVerifyInfo ? PageContent_VERIFY_INFO_STEP_NAME : PageContent_WELCOME_LANDING_PAGE_STEP_NAME;
    var logger = (0,analyticsHelper/* useEventLogger */.ld)({
        user_flow: "One-click enroll"
    });
    var handleEnrollEmployeeErrors = function(errors) {
        if (errors.errorStatus === globalTypes/* EnterpriseEnrollmentErrorStatus.MEMBER_EXISTS */.D7.MEMBER_EXISTS) {
            router.push("/".concat(groupName).concat(constants/* ENTERPRISE_ROUTES.CONNECT_ACCOUNT */.O$.CONNECT_ACCOUNT));
            return;
        }
        setSubmitting(false);
        var errorMessage = errors.errors[0].errorMessages[0].split("<")[0];
        logErrorViewed(logger, {
            message: errorMessage,
            stepName: stepName
        });
        if (errors.errorStatus === globalTypes/* EnterpriseEnrollmentErrorStatus.ENT_INELIGIBLE_EMAIL */.D7.ENT_INELIGIBLE_EMAIL || errorMessage.includes("already taken")) {
            setError({
                text: ELIGIBILITY_FAILURE
            });
            return;
        }
        setError({
            text: REQUEST_FAILED
        });
    };
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(GQL/* ENROLL_ENTERPRISE_EMPLOYEE */.Vx, {
        context: {
            skipAuth: true
        },
        onCompleted: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(res) {
                var __typename, memberId, appStateStringified, appState, nextPage;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            __typename = res.enrollSeekerForEnterpriseClient.__typename;
                            if (!(__typename === "EnterpriseEmployeeEnrollmentSuccess")) return [
                                3,
                                2
                            ];
                            memberId = res.enrollSeekerForEnterpriseClient.memberId;
                            logger({
                                name: constants/* EventNames.MEMBER_ENROLLED */.Vy.MEMBER_ENROLLED,
                                data: {
                                    care_company_name: groupName,
                                    member_id: memberId
                                }
                            });
                            appStateStringified = localStorageHelper/* SafeLocalStorage.getInstance */.m.getInstance().getItem(constants/* LOCAL_STORAGE_STATE_KEY */.qH) || "{}";
                            appState = JSON.parse(appStateStringified);
                            localStorageHelper/* SafeLocalStorage.getInstance */.m.getInstance().setItem(constants/* LOCAL_STORAGE_STATE_KEY */.qH, JSON.stringify((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, appState), {
                                flow: {
                                    memberId: memberId
                                }
                            })));
                            nextPage = "".concat(router.basePath).concat(constants/* memberEnrollment */.y).concat(constants/* ENTERPRISE_ROUTES.SET_PASSWORD */.O$.SET_PASSWORD);
                            return [
                                4,
                                authService.redirectLogin(nextPage, res.enrollSeekerForEnterpriseClient.authToken)
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            if (__typename === "EnterpriseEnrollmentProcessFailure") {
                                handleEnrollEmployeeErrors(res.enrollSeekerForEnterpriseClient);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(res) {
                return _ref.apply(this, arguments);
            };
        }(),
        onError: function(err) {
            logErrorViewed(logger, {
                message: err.message,
                stepName: stepName
            });
            setSubmitting(false);
            setError({
                text: REQUEST_FAILED
            });
        }
    }), 1), enrollEmployee = ref6[0];
    (0,useQuery/* useQuery */.a)(GQL/* GET_ENTERPRISE_EMPLOYEE_VERIFICATION_RECORD */.fq, {
        context: {
            skipAuth: true
        },
        variables: {
            input: {
                employeeVerificationId: employeeUUID,
                groupShortName: groupName
            }
        },
        fetchPolicy: "cache-and-network",
        onCompleted: function(data) {
            var ref;
            if ((data === null || data === void 0 ? void 0 : (ref = data.enterpriseEnrollmentEmployeeVerification) === null || ref === void 0 ? void 0 : ref.__typename) === "EnterpriseEnrollmentEmployeeVerificationSuccess") {
                var ref1;
                var employeeVerificationData = (ref1 = data.enterpriseEnrollmentEmployeeVerification) === null || ref1 === void 0 ? void 0 : ref1.employeeVerification;
                var hasFirstOrLastName = (employeeVerificationData === null || employeeVerificationData === void 0 ? void 0 : employeeVerificationData.firstName) || (employeeVerificationData === null || employeeVerificationData === void 0 ? void 0 : employeeVerificationData.lastName);
                if (!hasFirstOrLastName && !(employeeVerificationData === null || employeeVerificationData === void 0 ? void 0 : employeeVerificationData.careGroupName)) {
                    evaluateOneClickLogger();
                    logErrorViewed(logger, {
                        message: "Employee verification response does not have firstName & lastName & careGroupName",
                        stepName: stepName
                    });
                    router.push("".concat(constants/* memberEnrollment */.y).concat(WELCOME));
                    return;
                }
                update({
                    firstName: employeeVerificationData.firstName || "",
                    lastName: employeeVerificationData.lastName || "",
                    email: employeeVerificationData.emailAddress,
                    employeeId: employeeVerificationData.employeeId,
                    address: STREET_ADDRESS,
                    zipCode: ZIP_CODE,
                    groupShortName: groupName,
                    dateOfBirth: null,
                    groupDisplayName: (employeeVerificationData === null || employeeVerificationData === void 0 ? void 0 : employeeVerificationData.careGroupName) || undefined
                });
                if (!(employeeVerificationData === null || employeeVerificationData === void 0 ? void 0 : employeeVerificationData.firstName) || !(employeeVerificationData === null || employeeVerificationData === void 0 ? void 0 : employeeVerificationData.lastName)) {
                    logV1OneClickEnrollToAmplitude();
                    setShowVerifyInfo(true);
                } else {
                    evaluateOneClickLogger();
                    setShowLandingPage(true);
                }
                setIsLoading(false);
            } else {
                var ref2;
                evaluateOneClickLogger();
                var errorMessage = (ref2 = data.enterpriseEnrollmentEmployeeVerification) === null || ref2 === void 0 ? void 0 : ref2.rawErrorMessage;
                logErrorViewed(logger, {
                    message: errorMessage,
                    stepName: stepName
                });
                router.push("".concat(constants/* memberEnrollment */.y).concat(WELCOME));
            }
        },
        onError: function(err) {
            evaluateOneClickLogger();
            logErrorViewed(logger, {
                message: err.message,
                stepName: stepName
            });
            router.push("".concat(constants/* memberEnrollment */.y).concat(WELCOME));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
    });
    var handleCreateAccount = function(val) {
        if (showVerifyInfo && isOneClickV2 || !isOneClickV2) {
            logger({
                name: constants/* EventNames.CTA_INTERACTED */.Vy.CTA_INTERACTED,
                data: {
                    cta_text: createAccount,
                    step_name: stepName
                }
            });
        }
        // we only want to update these values if the user entered fname/lname
        // in the form, otherwise it will set the values to null
        if (showVerifyInfo) {
            update({
                firstName: val.firstName,
                lastName: val.lastName
            });
        }
        setSubmitting(true);
        var ref = fetch(), address = ref.address, firstName = ref.firstName, lastName = ref.lastName, zipCode = ref.zipCode, email = ref.email, employeeId = ref.employeeId;
        var employeeInformation = {
            address: address,
            firstName: firstName,
            lastName: lastName,
            email: email,
            zip: zipCode,
            employeeId: employeeId,
            password: (0,passwordGenerate/* passwordGenerate */.E)()
        };
        enrollEmployee({
            variables: {
                input: {
                    group: groupName,
                    employeeInformation: employeeInformation
                }
            }
        });
    };
    var evaluateOneClickLogger = function() {
        if (isOneClickV2) {
            logV2OneClickEnrollToAmplitude();
        } else {
            logV1OneClickEnrollToAmplitude();
        }
    };
    var logV1OneClickEnrollToAmplitude = function() {
        logger({
            name: ONE_CLICK_ENROLL_EVENT_NAME
        });
    };
    var logV2OneClickEnrollToAmplitude = function() {
        logger({
            name: ONE_CLICK_ENROLL_V2_EVENT_NAME
        });
    };
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: (0,_object_spread/* default */.Z)({}, fetch()),
        validationSchema: getOneClickSchemaValidation(),
        onSubmit: handleCreateAccount,
        validateOnMount: false,
        enableReinitialize: true
    });
    // With the boolean check for showLandingPage, it'll infinite loop
    // because React will re-render continuously.
    if (showLandingPage && isOneClickV2) {
        handleCreateAccount(fetch());
        setShowLandingPage(false);
    }
    (0,useEnterKey/* default */.Z)(!isOverlayOpen, formik.submitForm);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlaySpinner/* default */.Z, {
                isOpen: isOverlayOpen,
                isTransparent: isSubmitting && (!isOneClickV2 || showVerifyInfo),
                transitionDuration: {
                    appear: 0,
                    exit: 225
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* FormikProvider */.Hy, {
                value: formik,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepCard/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorNotification/* default */.Z, {
                            text: error === null || error === void 0 ? void 0 : error.text,
                            subText: error === null || error === void 0 ? void 0 : error.subText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            children: [
                                showVerifyInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerifyInfo, {
                                    logger: logger
                                }),
                                showLandingPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Landing, {
                                    logger: logger
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StepCTA/* default */.Z, {
                            onClick: formik.submitForm,
                            ctaType: ctaType
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsOfUse/* default */.Z, {
                            amplitudeLogger: logger,
                            buttonCaption: createAccount,
                            variant: "abbreviated"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_PageContent = (PageContent);

// EXTERNAL MODULE: ./src/components/shared/FooterWhiteBackgroundWrapper.tsx
var FooterWhiteBackgroundWrapper = __webpack_require__(82762);
;// CONCATENATED MODULE: ./src/components/pages/MemberEnrollment/OneClick/index.tsx












var OneClick_WELCOME = constants/* ENTERPRISE_ROUTES.WELCOME */.O$.WELCOME;
var OneClickEnrollmentPage = function() {
    var router = (0,next_router.useRouter)();
    var groupName = router.query.groupName;
    var employeeUUID = router.query.id;
    var ref = config_default()(), CZEN_GENERAL = ref.publicRuntimeConfig.CZEN_GENERAL;
    if (!groupName || !employeeUUID) {
        router.push("".concat(constants/* memberEnrollment */.y).concat(OneClick_WELCOME));
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    // evaluate one click enrollment LD flag, if false redirect to welcome page
    var oneClickEnrollEval = (0,FeatureFlagsContext/* useFlag */.P5)(constants/* FEATURE_FLAGS.ENT_ONE_CLICK_ENROLLMENT_FLAG.key */.y8.ENT_ONE_CLICK_ENROLLMENT_FLAG.key);
    var oneClickEnrollV2Eval = (0,FeatureFlagsContext/* useFlag */.P5)(constants/* FEATURE_FLAGS.ENT_ONE_CLICK_ENROLLMENT_V2_FLAG.key */.y8.ENT_ONE_CLICK_ENROLLMENT_V2_FLAG.key);
    // TODO: Resolve during code review or earlier
    // For code review: having v2 on and v1 off is a misconfig, we can add the check here
    // too if we want to be extra cautious. Else we can leave it like this.
    if (!oneClickEnrollEval) {
        router.push("".concat(constants/* memberEnrollment */.y).concat(OneClick_WELCOME));
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageHeader/* default */.Z, {
                logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(CareLogo/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PageContent, {
                    groupName: groupName,
                    employeeUUID: employeeUUID,
                    isOneClickV2: oneClickEnrollV2Eval
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterWhiteBackgroundWrapper/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppFooter/* default */.Z, {
                    baseUrl: CZEN_GENERAL
                })
            })
        ]
    });
};
/* harmony default export */ var OneClick = (OneClickEnrollmentPage);

;// CONCATENATED MODULE: ./src/pages/member-enrollment/one-click.tsx



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [303,405,774,888,179], function() { return __webpack_exec__(4876); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);